<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0"><b-icon icon="info-circle" class="mr-2 module-help-information" v-b-popover.hover="help" v-if="help && help.content"></b-icon>Proyectos</h4>
            <div class="small text-muted">Panel de control de toda la gestión de proyectos</div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
            <ChangelogWidget moduleKey="projects" :limit="5" />
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">  
          <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">

            <b-tab title="General" :active="tabs.main" @click="setActiveTab('main')">
              <WidgetMasonry
                v-if="visibilityLoaded"
                v-model="widgetsOrderedMain"
                :disabled="!visibilityLoaded || editingLocked"
                @order-end="saveWidgetOrder"
                @resize-end="commitWidgetSize"
              >
                <template v-slot:default="{ item }">
                    <Widget
                      :configWidget="configWidget"
                      :reference="item.reference"
                      :hasAccess="item.hasAccess"
                      :allowHide="!editingLocked"
                      :allowDrag="!editingLocked"
                      :allowResize="!editingLocked"
                      @hide-widget="hideWidget"
                    />
                </template>
              </WidgetMasonry>

            </b-tab>
            <b-tab title="Proyectos con Vencimiento" :active="tabs.with_expiration" @click="setActiveTab('with_expiration')">
              <WidgetMasonry
                v-if="visibilityLoaded"
                v-model="widgetsOrderedWithExpiration"
                :disabled="!visibilityLoaded || editingLocked"
                @order-end="saveWidgetOrder"
                @resize-end="commitWidgetSize"
              >
                <template v-slot:default="{ item }">
                    <Widget
                      :configWidget="configWidget"
                      :reference="item.reference"
                      :hasAccess="item.hasAccess"
                      :allowHide="!editingLocked"
                      :allowDrag="!editingLocked"
                      :allowResize="!editingLocked"
                      @hide-widget="hideWidget"
                    />
                </template>
              </WidgetMasonry>
            </b-tab>
            <b-tab title="Proyectos sin Vencimiento" :active="tabs.without_expiration" @click="setActiveTab('without_expiration')">
              <WidgetMasonry
                v-if="visibilityLoaded"
                v-model="widgetsOrderedWithoutExpiration"
                :disabled="!visibilityLoaded || editingLocked"
                @order-end="saveWidgetOrder"
                @resize-end="commitWidgetSize"
              >
                <template v-slot:default="{ item }">
                    <Widget
                      :configWidget="configWidget"
                      :reference="item.reference"
                      :hasAccess="item.hasAccess"
                      :allowHide="!editingLocked"
                      :allowDrag="!editingLocked"
                      :allowResize="!editingLocked"
                      @hide-widget="hideWidget"
                    />
                </template>
              </WidgetMasonry>
            </b-tab>
          </b-tabs>                                
        </b-col>
        <b-col md="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.projects">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openProjects()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Proyectos</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de proyectos
              </p>
            </b-list-group-item>
          </b-list-group>          

          <b-list-group class="mb-1" v-if="(!isEmployee || getEmployeePermission) && configSubView.elements.activity">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openActivity()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Actividad</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de actividades
              </p>
            </b-list-group-item>
          </b-list-group>      

          <b-list-group class="mb-1" v-if="(isEmployee || getEmployeePermission) && configSubView.elements.hours">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openHours()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Horas</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Gestión de horas consumidas
              </p>
            </b-list-group-item>
          </b-list-group>  

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
import ChangelogWidget from '@/components/inc/changelog/ChangelogWidget'
  import Storage from '@/handler/storageLocal'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry,
      ChangelogWidget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PROYECTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.PROYECTOS,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.PROYECTOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            projects: true,
            activity: true,
            hours: true,
            php_custom: true,
          }
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        },        
        help: {
          title:'¿Cómo funciona este módulo?',
          content: () => { 
            return `Un usuario con perfil <b>STAFF</b>, es el administrador del módulo, 
                    el cual puede visualizar toda la información de forma generalizada. Podrá crear 
                    nuevos proyectos y armar equipos de trabajo.
                    <br><br>
                    Un usuario con perfil <b>STAFF</b> y configurado como <b>EMPLEADO</b>, puede ser asignado como
                    responsable de un proyecto o estar incluido dentro de un equipo de trabajo. Este usuario 
                    podrá cargar las horas de trabajo.`
          },            
          html: true
        },
        tabs: {
          main: true,
          with_expiration: false,
          without_expiration: false,
        },
        widgetGroups: {
          main: [
            'pie_activity_project',
            'pie_detail_project',
            'pie_detail_activity',
            'list_days_incomplete_hours'
          ],
          with_expiration: [
            'pie_projects_status',
            'list_projects_vencimientos_treinta_dias',
            'list_hours_estimated_vs_hurs_real'
          ],
          without_expiration: [
            'pie_projects_status_without_expiration',
            'list_hours_real_project_without_expiration'
          ]
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
      this.initDashboardWidgets()

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.projects = Helper.showAccessView(this.configSubView, 'crudProject')            
      this.configSubView.elements.activity = Helper.showAccessView(this.configSubView, 'crudActivity')            
      this.configSubView.elements.hours = Helper.showAccessView(this.configSubView, 'crudHours')            
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */                  
    },
    mounted() {
      this.setup()
      this.getPHPCustom()

      this.restoreStatusTabsStorage()
    }, 
    computed: {
      isEmployee(){
        if(Helper.getEmployee()) {
          return true
        } else {
          return false
        }
      },
      getEmployeePermission() {
        if(this.isEmployee) {
          return Helper.getEmployee().permission_admin_projects
        } else {
          return false
        }
      },
      widgetsOrderedMain: {
        get() {
          return this.widgetsOrdered.filter(item => this.widgetGroups.main.indexOf(item.reference) !== -1)
        },
        set(value) {
          this.mergeWidgetOrder('main', value)
        }
      },
      widgetsOrderedWithExpiration: {
        get() {
          return this.widgetsOrdered.filter(item => this.widgetGroups.with_expiration.indexOf(item.reference) !== -1)
        },
        set(value) {
          this.mergeWidgetOrder('with_expiration', value)
        }
      },
      widgetsOrderedWithoutExpiration: {
        get() {
          return this.widgetsOrdered.filter(item => this.widgetGroups.without_expiration.indexOf(item.reference) !== -1)
        },
        set(value) {
          this.mergeWidgetOrder('without_expiration', value)
        }
      }
    },    
    methods: {
      mergeWidgetOrder(group, order) {
        const refs = this.widgetGroups[group] || []
        if(!refs.length) {
          return
        }
        const current = this.widgetsOrdered.slice()
        const others = current.filter(item => refs.indexOf(item.reference) === -1)
        const firstIndex = current.findIndex(item => refs.indexOf(item.reference) !== -1)
        const insertAt = firstIndex === -1 ? others.length : firstIndex
        const next = others.slice(0, insertAt).concat(order, others.slice(insertAt))
        this.widgetsOrdered = next
      },
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openProjects() {
        this.$router.push({ name: 'ProjectStaffCrudProject' })
      },    
      openActivity() {
        this.$router.push({ name: 'ProjectStaffCrudActivity' })
      },    
      openHours() {
        this.$router.push({ name: 'ProjectStaffCrudHours' })
      },  
      
      //TABS
      disableAllTabs() {
        this.tabs.main = false
        this.tabs.with_expiration = false
        this.tabs.without_expiration = false
      },
      setActiveTab(value) {
        this.disableAllTabs()

        switch (value) {
          case 'main':
            this.tabs.main = true
            break;

          case 'with_expiration':
            this.tabs.with_expiration = true
            break;
        
          case 'without_expiration':
            this.tabs.without_expiration = true
            break;

          default:
            this.tabs.main = true
            break;
        }

        this.saveStatusTabsStorage()
      },  

      // FILTROS SAVE
      saveStatusTabsStorage() {
        Storage.setValue('tabs_view_dashboard_projects', JSON.stringify(this.tabs))
      },
      restoreStatusTabsStorage() {
        if(Storage.getValue('tabs_view_dashboard_projects')) {
          this.tabs = JSON.parse(Storage.getValue('tabs_view_dashboard_projects'))
        }         
      },  

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.PROYECTOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>
